<div *ngIf="isAlertVisible" class="mx-auto max-w-prose">
  <div
    class="rounded-xl bg-warning py-6 px-4 text-center text-sm text-apricot-1"
  >
    <p>
      Den här utövaren verkar inte ha några lediga tider inom den närmaste
      månaden.
    </p>
  </div>

  <app-ui-button
    (onClick)="redirectToNext()"
    [color]="'green'"
    [compressed]="false"
    [expanded]="'block'"
    [size]="'md'"
    class="test-booking-redirect-btn mt-4 mb-2 block"
  >
    Leta efter tider nästa månad
  </app-ui-button>

  <app-ui-button
    (click)="redirectToAll()"
    *ngIf="!isDoctorMandatory"
    [expanded]="'block'"
    color="ghost"
  >
    Visa tider hos alla utövare
  </app-ui-button>
  <app-ui-button
    (click)="openDoctorSelector()"
    *ngIf="isDoctorMandatory"
    [expanded]="'block'"
    color="ghost"
  >
    Välj en annan utövare
  </app-ui-button>
</div>
